import { render, staticRenderFns } from "./HospitalClinic.vue?vue&type=template&id=b41ebff8&scoped=true&"
import script from "./HospitalClinic.vue?vue&type=script&lang=js&"
export * from "./HospitalClinic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b41ebff8",
  null
  
)

export default component.exports